import React, { useEffect } from "react";
import '../BitsStyles/Services.css';

const services = [
  {
    id: 'web-app',
    icon: 'bi-display',
    accent: '#0066cc',
    title: 'Web App Development',
    items: [
      'Website development',
      'Web Applications',
      'E-commerce Web App development',
      'Hospital Management',
      'Software Applications',
      'Software Development and Tools',
    ],
    badge: 'Most Popular',
    stat: '10+',
    statLabel: 'Projects',
  },
  {
    id: 'mobile-app',
    icon: 'bi-phone',
    accent: '#0052a3',
    title: 'Mobile App Development',
    items: [
      'Android app development',
      'iOS app development',
      'React Native Cross Platform App Development',
      'Mobile App Support & Maintenance',
      'Flutter Cross Platform App Development',
    ],
    stat: '10+',
    statLabel: 'Apps Launched',
  },
  {
    id: 'billing',
    icon: 'bi-receipt-cutoff',
    accent: '#003d7a',
    title: 'Billing Solutions',
    items: [
      'Billing Analytics and Reporting',
      'Billing software Integration',
      'Custom Billing Solutions',
      'Payment gateway Integration',
      'Billing Systems Development',
    ],
    stat: '5+',
    statLabel: 'Integrations',
  },
  {
    id: 'it-support',
    icon: 'bi-headset',
    accent: '#004f9e',
    title: 'IT Support Projects',
    items: [
      'Software Support Projects',
      'Custom Software development',
      'Helpdesk Ticketing System Implementation',
      'API Integration',
    ],
    badge: '24/7',
    stat: '99%',
    statLabel: 'Uptime SLA',
  },
];

const ExpertiseSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.service-card').forEach(card => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="expertise-section">
      <h2 className="services-heading">We Work With</h2>

      <div className="services-container">
        {services.map((svc, index) => (
          <div
            key={svc.id}
            className="service-card"
            style={{ '--card-accent': svc.accent }}
          >
            {svc.badge && (
              <span className="service-badge">{svc.badge}</span>
            )}

            <div className="service-icon-wrap">
              <i className={`bi ${svc.icon}`}></i>
            </div>

            <h2 className="service-title">{svc.title}</h2>

            <ul className="service-list">
              {svc.items.map((item, i) => (
                <li key={i}>
                  <span className="check-icon">&#10003;</span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="service-card-footer">
              <div className="service-stat">
                <span className="service-stat-number">{svc.stat}</span>
                <span className="service-stat-label">{svc.statLabel}</span>
              </div>
              <div className="service-card-bar"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExpertiseSection;
